<template>
  <div>
    <b-col cols="12">
      <DataTable
        :loading="loading"
        :columns="columns"
        :rows="rows"
        clases="table-bordered table-hover table-condensed nowrap">
      </DataTable>
    </b-col>
  </div>
</template>

<script>
import { userService } from '@/services';

export default {
  props: {
    usuario:{}
  },
  data(){
    return {
      loading: true,
      columns:[
        {label: 'Acción', field: 'comentario'},
        {label: 'Fecha', field: 'fecha'},
        {label: 'Usuario responsable', field: 'nombre_usuario'}
        ],
      rows:[],
    }
  },
  mounted () {
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Configuración / Usuario ' + this.usuario.nombre_usuario+ ' / Historial');
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      userService.getUsuarioHistorial({
        id_cliente:this.$store.state.usuario.id_cliente,
        id_usuario:this.usuario.id_usuario
      }).then(data => {
        this.rows = data.data;

        this.loading = false;
      });
    },
  }
}
</script>

<style scoped>
</style>
